import { useEffect, useState, useMemo, useCallback } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useParams } from "react-router-dom";
import { createColumnHelper } from "@tanstack/react-table";
import PageLayout from "../../components/PageLayout";
import LoadingSpinner from "../../components/LoadingSpinner";
import AddPropertyByCode from "../../components/AddPropertyByCode";
import { setAgencyRecommendationsColumns } from "../../constants/columnDefs/agencyRecommendations";
import {
  addAgencyRecommendation,
  deleteAgencyRecommendation,
  getAgenciesRecommendationsAgent,
} from "../../state/actions/propertyActions";
import styles from "./styles.module.sass";

const columnHelper = createColumnHelper();

const AgencyRecommendations = () => {
  const dispatch = useDispatch();
  const params = useParams();
  const properties = useSelector(
    (state) => state.property.agencyRecommendedProperties
  );
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setLoading(true);
    dispatch(getAgenciesRecommendationsAgent()).finally(() =>
      setLoading(false)
    );
  }, [dispatch]);

  const handleAddRecommendation = useCallback(
    (code) => dispatch(addAgencyRecommendation(code)),
    [dispatch]
  );

  const handleDeleteRecommendation = useCallback(
    (id) => dispatch(deleteAgencyRecommendation(id)),
    [dispatch]
  );

  const mappingArray = useMemo(
    () =>
      Object.keys(properties).map((agencyName) => ({
        name: agencyName,
        properties: properties[agencyName].map((item) => ({
          _id: item.id,
          propertyId: item.property_info?.property_code,
          type: item.property_info?.type,
          city: item.property_info?.city?.name,
          area: item.property_info?.area,
          propertySize: item.property_info?.property_size,
          price: item.property_info?.price,
          date: item.property_info?.date,
          contract: item.property_info?.contract,
          publish: item.property_info?.publish,
        })),
      })),
    [properties]
  );

  const mappedColumns = useMemo(
    () =>
      setAgencyRecommendationsColumns(
        columnHelper,
        mappingArray[0]?.properties,
        handleDeleteRecommendation
      ),
    [mappingArray, handleDeleteRecommendation]
  );

  return (
    <>
      {loading ? (
        <div>
          <LoadingSpinner />
        </div>
      ) : (
        <div className={styles.subcontainer}>
          {!mappingArray.length && (
            <AddPropertyByCode
              onAdd={handleAddRecommendation}
              successMessage="Uspešno dodata preporuka"
              errorMessage="Neuspešno dodata preporuka"
            />
          )}
          {mappingArray.map((agency, index) => (
            <div key={agency.name || index} className="mb-5">
              <h3 className="mb-1">{agency.name}</h3>
              <AddPropertyByCode
                onAdd={handleAddRecommendation}
                successMessage="Uspešno dodata preporuka"
                errorMessage="Neuspešno dodata preporuka"
              />
              <div className={styles.container}>
                <PageLayout
                  dataArray={agency.properties}
                  columns={mappedColumns}
                  pagination={true}
                  allowFilters={true}
                  filters={[]}
                />
              </div>
            </div>
          ))}
        </div>
      )}
    </>
  );
};

export default AgencyRecommendations;
